'use strict';
import {Component, Inject, Input} from '@angular/core';
import {Store}  from '@ngrx/store';
import {selectActiveVehicle} from '@ox/data';
import {Asset, Brands, FeatureCopy, Vehicle} from '@ox/typings';
import {AutoDestroy, BRAND, replaceVariable} from '@ox/utils';
import {catchError, map, Subject, takeUntil} from 'rxjs';

@Component({
  selector: 'webu-about-plan-feature',
  templateUrl: './about-plan-feature.component.html'
})
export class AboutPlanFeatureComponent {
  @AutoDestroy destroy$: Subject<void> = new Subject<void>();
  @Input() featureCopy: FeatureCopy;
  @Input() featureImageAsset?: Asset;

  brand$ = this.store.select(selectActiveVehicle).pipe(
    takeUntil(this.destroy$),
    map((vehicle: Vehicle | undefined) => vehicle?.make ? vehicle.make : this.brand),
    catchError(() => this.brand)
  );
  
  constructor(private store: Store,
    @Inject(BRAND) public brand: Brands) {}

  addBrandToDescription(description: string | undefined, brand: string | null) {
    if(!description || !brand) return undefined;
    else return replaceVariable(description, {Brand: brand});
  }
}
